<template>

<div class="supplementary">

	<div class="supplementary-overlay" v-on:click="onCloseClick"></div>

	<div class="supplementary-panel">

		<div class="supplementary-header">

			<div class="supplementary-title">{{ actionTitle }}</div>

			<button class="supplementary-close" v-on:click="onCloseClick">&times;</button>

		</div>

		<template v-if="state === 'form'">

			<div class="supplementary-body">

				<div class="supplementary-errors" v-if="errors.length">

					<div class="supplementary-errors-item" v-for="(error, index) in errors" :key="index">
						<i class="fa-solid fa-circle-exclamation"></i>
						<span>{{ error }}</span>
					</div>

				</div>

				<template v-for="section in sections">

					<com-form :section="section" :key="section.id" v-if="section.id === currentQuestion" />

				</template>

			</div>

			<div class="supplementary-footer">

				<button class="supplementary-button supplementary-button-cancel" v-on:click="onCloseClick">Cancel</button>

				<button class="supplementary-button supplementary-button-next" v-on:click="onSubmitClick" :disabled="state !== 'form'">Confirm</button>

			</div>

		</template>

		<template v-if="state === 'saving'">

			<div class="supplementary-body supplementary-state">

				<i class="fa-solid fa-spinner fa-spin supplementary-state-icon"></i>

				<div class="supplementary-state-text">Sending...</div>

			</div>

		</template>

		<template v-if="state === 'success'">

			<div class="supplementary-body supplementary-state">

				<div class="supplementary-state-badge"><i class="fa-solid fa-check"></i></div>

				<div class="supplementary-state-title">Code Generated</div>

				<div class="supplementary-state-code" v-if="code">{{ code }}</div>

				<div class="supplementary-state-text">Copy and paste this code into an email/SMS to the patient using your practice's approved communication platform.</div>

			</div>

			<div class="supplementary-footer">

				<button class="supplementary-button supplementary-button-next" v-on:click="onCloseClick">Done</button>

			</div>

		</template>

	</div>

</div>

</template>

<script>

import comForm from './../../common/section/Form'

export default {

	props: ['trigger'],

	components: {

		'com-form': comForm

	},

	data: function() {

		return {
			state: 'form'
		}

	},

	computed: {

		sections: function() {

			return this.$store.getters['data/form/sections/nextstep']

		},

		currentQuestion: function() {

			return this.$store.getters['session/bridge'].question

		},

		errors: function() {

			return this.$store.getters['session/bridge/errors']

		},

		code: function() {

			return this.$store.getters['session/bridge/code']

		},

		actionTitle: function() {

			var active = this.$store.getters['session/bridge/active']
			return active ? active.text : 'Next Steps'

		}

	},

	created: function() {

		if (!this.currentQuestion) {

			this.$store.dispatch('bridge/proceed')

		}

	},

	methods: {

		onSubmitClick: function() {

			this.$store.dispatch('bridge/proceed')

			if (this.$store.getters['session/bridge/step'] === 'complete') {

				if (this.trigger === 'bridge') {

					this.state = 'saving'

					this.$api.request('bridge/save', {
						values: this.$store.getters['session/values'],
						answers: this.$store.getters['session/bridge'].questions,
						recommendation: this.$store.getters['session/recommendation']
					}).then(function(response) {

						this.$store.commit('session/bridge/code', response.code)
						this.$store.commit('session/bridge/completed', this.$store.getters['session/bridge/active'].id)
						this.state = 'success'

					}.bind(this))

				} else {

					this.$emit('complete')

				}

			}

		},

		onCloseClick: function() {

			this.$emit('cancel')

		}

	}

}

</script>

<style scoped>

.supplementary {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 2000;
	display: flex;
	align-items: center;
	justify-content: center;
}

.supplementary-overlay {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
}

.supplementary-panel {
	position: relative;
	background-color: #fff;
	border-radius: 16px;
	width: 90%;
	max-width: 800px;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.is-mobile .supplementary-panel {
	width: 100%;
	max-width: 100%;
	max-height: 100%;
	height: 100%;
	border-radius: 0;
}

.supplementary-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 24px 32px;
	border-bottom: 1px solid #e0e0e0;
	flex-shrink: 0;
}

.is-mobile .supplementary-header {
	padding: 16px 20px;
}

.supplementary-title {
	font-size: 20px;
	font-weight: 700;
	color: #343434;
}

.is-mobile .supplementary-title {
	font-size: 16px;
}

.supplementary-close {
	font-size: 28px;
	color: #999;
	cursor: pointer;
	line-height: 1;
	background: none;
	border: none;
	padding: 0;
}

.supplementary-close:hover {
	color: #343434;
}

.supplementary-body {
	flex: 1;
	overflow-y: auto;
	padding: 32px;
}

.is-mobile .supplementary-body {
	padding: 20px;
}

.supplementary-body >>> .input-label-title {
	font-size: 16px;
	line-height: 20px;
}

.supplementary-errors {
	background-color: #ee7173;
	border-radius: 12px;
	padding: 20px 24px;
	margin-bottom: 24px;
}

.supplementary-errors-item {
	color: #fff;
	font-size: 16px;
	font-weight: 700;
	line-height: 24px;
	padding: 4px 0;
}

.supplementary-errors-item i {
	margin-right: 10px;
}

.supplementary-errors-item span {
	flex: 1;
}

.supplementary-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 48px 32px;
	text-align: center;
}

.supplementary-state-icon {
	font-size: 40px;
	color: var(--primary-color);
	margin-bottom: 16px;
}

.supplementary-state-badge {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: #4CAF50;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 24px;
}

.supplementary-state-badge i {
	color: #fff;
	font-size: 28px;
}

.supplementary-state-title {
	font-size: 24px;
	font-weight: 700;
	color: #343434;
	margin-bottom: 16px;
}

.supplementary-state-code {
	font-size: 36px;
	font-weight: 700;
	letter-spacing: 6px;
	color: #343434;
	padding: 16px 32px;
	background-color: #f5f5f5;
	border-radius: 12px;
	font-family: monospace;
	margin-bottom: 24px;
}

.is-mobile .supplementary-state-code {
	font-size: 24px;
	letter-spacing: 4px;
	padding: 12px 20px;
}

.supplementary-state-text {
	font-size: 16px;
	color: #666;
	line-height: 24px;
	max-width: 450px;
}

.is-mobile .supplementary-state-text {
	font-size: 14px;
	line-height: 20px;
}

.supplementary-footer {
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	padding: 20px 32px;
	border-top: 1px solid #e0e0e0;
	flex-shrink: 0;
}

.is-mobile .supplementary-footer {
	padding: 16px 20px;
	flex-direction: column;
}

.is-mobile .supplementary-button {
	width: 100%;
	text-align: center;
}

.supplementary-button {
	padding: 12px 32px;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 200ms ease-in-out;
}

.supplementary-button:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.supplementary-button-cancel {
	background-color: #f0f0f0;
	color: #666;
	border: 1px solid #ddd;
}

.supplementary-button-cancel:hover {
	background-color: #e0e0e0;
}

.supplementary-button-next {
	background-color: var(--primary-color);
	color: #fff;
	border: none;
}

.supplementary-button-next:hover {
	filter: brightness(90%);
}

</style>
